export class SimpleDate
{
    public day: number;
    public month: number;
    public year: number;

    public constructor();
    public constructor(str: string);
    public constructor(year: number, month: number, day: number);

    public constructor(yearOrStr?: number | string, month?: number, day?: number)
    {
        // 0-arg version -> Initialize to Sunday starting this week
        if (yearOrStr === undefined && month === undefined && day === undefined)
        {
            const startDate = new Date();
            const currentDayOfWeek = startDate.getDay();

            // Days from today to the previous Sunday
            const daysToSunday = currentDayOfWeek;
            startDate.setDate(startDate.getDate() - daysToSunday);

            // Update the SimpleDate properties with the new values
            // (Months are 0-based in Date)
            this.year = startDate.getFullYear();
            this.month = startDate.getMonth() + 1;
            this.day = startDate.getDate();
        }
        // 1-arg version -> Parse the str
        else if (typeof yearOrStr === 'string')
        {
            const dateRegex = /^(\d{4})-(\d{2})-(\d{2})$/;
            const match = dateRegex.exec(yearOrStr);
            if (match)
            {
                this.year = parseInt(match[1]);
                this.month = parseInt(match[2]);
                this.day = parseInt(match[3]);
            } else
            {
                throw new Error('Invalid date string format');
            }
        }
        // 3-arg version -> use year / month / day
        else if (typeof yearOrStr === 'number' && typeof month === 'number' && typeof day === 'number')
        {
            this.year = yearOrStr;
            this.month = month;
            this.day = day;
        } else
        {
            throw new Error('Invalid constructor arguments');
        }
    }

    public addDays(days: number): SimpleDate
    {
        // Create a Date object using the current SimpleDate
        const date = new Date(this.year, this.month - 1, this.day);

        // Add the specified number of days
        date.setDate(date.getDate() + days);

        // Return a new SimpleDate properties with the new values
        // (Months are 0-based in Date)
        return new SimpleDate(date.getFullYear(), date.getMonth() + 1, date.getDate());
    }

    public equals(otherDate: SimpleDate): boolean
    {
        return (this.toString() === otherDate.toString());
    }

    public toString(): string
    {
        const formattedYear = this.year.toString().padStart(2, '0');
        const formattedMonth = this.month.toString().padStart(2, '0');
        const formattedDay = this.day.toString().padStart(2, '0');

        return `${formattedYear}-${formattedMonth}-${formattedDay}`;
    }

    public toShortString(): string
    {
        const monthNames = [
            'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
        ];
        const monthString = monthNames[this.month - 1];
        return `${monthString} ${this.day}`;
    }
}
